module.exports = __webpack_public_path__ + "static/media/privacy_es.7dc28da4.txt";